<template>
  <div>
    <HealthCoursesComp v-bind:mobile="mobile"/>
    <RedirectActivitiesComp v-bind:mobile="mobile"/>
    <FollowUs v-bind:mobile="mobile"/>
  </div>
</template>

<script>
import RedirectActivitiesComp from '@/components/desktop/Activities/RedirectActivitiesComp'
import HealthCoursesComp from "@/components/desktop/Activities/HealthCoursesComp";
import FollowUs from '@/components/desktop/FollowUs'

  export default {
    name: 'HealthCourses',
    props: ['mobile'],
    components: {
      HealthCoursesComp,
      RedirectActivitiesComp,
      FollowUs
    },
  }
</script>
